export default __webpack_public_path__ + "static/media/same-tone-generator.b6fcd1c6.png";